import { render, staticRenderFns } from "./DotListItem.vue?vue&type=template&id=1f5c2904&scoped=true&"
import script from "./DotListItem.vue?vue&type=script&lang=ts&"
export * from "./DotListItem.vue?vue&type=script&lang=ts&"
import style0 from "./DotListItem.vue?vue&type=style&index=0&id=1f5c2904&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c2904",
  null
  
)

export default component.exports